export const ANALYTICS_MEDIA_CHANNEL = 'media';
